import { render, staticRenderFns } from "./columnBtn.vue?vue&type=template&id=151b93d2"
import script from "./columnBtn.vue?vue&type=script&lang=js"
export * from "./columnBtn.vue?vue&type=script&lang=js"
import style0 from "./columnBtn.vue?vue&type=style&index=0&id=151b93d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports